import { common as nlCommon } from './nl/common';
import { common as enCommon } from './en/common';
import { common as frCommon } from './fr/common';
import { home as nlHome } from './nl/home';
import { home as enHome } from './en/home';
import { home as frHome } from './fr/home';
import { about as nlAbout } from './nl/about';
import { about as enAbout } from './en/about';
import { about as frAbout } from './fr/about';
import { privacy as nlPrivacy } from './nl/privacy';
import { privacy as enPrivacy } from './en/privacy';
import { privacy as frPrivacy } from './fr/privacy';
import { terms as nlTerms } from './nl/terms';
import { terms as enTerms } from './en/terms';
import { terms as frTerms } from './fr/terms';
import { cookie as nlCookie } from './nl/cookie';
import { cookie as enCookie } from './en/cookie';
import { cookie as frCookie } from './fr/cookie';

const resources = {
  nl: {
    common: nlCommon,
    home: nlHome,
    about: nlAbout,
    privacy: nlPrivacy,
    terms: nlTerms,
    cookie: nlCookie
  },
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    privacy: enPrivacy,
    terms: enTerms,
    cookie: enCookie
  },
  fr: {
    common: frCommon,
    home: frHome,
    about: frAbout,
    privacy: frPrivacy,
    terms: frTerms,
    cookie: frCookie
  }
};

export default resources;